import { Icon } from '../../widgets/icon';
import { Link } from '../../widgets/buttons';
import { VerticalLayout } from '../../widgets/layouts';
import React from 'react';
import { Section } from 'src/components/widgets/section';
import styled from 'styled-components';
import EmptyListIcon from '../../..//shared/icons/page-error-icon.svg';
import { backofficeUrl, removeCookie, T } from '../../../shared/helpers';

const PageContainer = styled(VerticalLayout)`
    margin-top: 40px;
`;

const TopIcon = styled(Icon)`
    height: 120px;
    width: 120px;
    margin: auto;
    display: block;
`;

const EmptyListContainer = styled.div`
    max-width: 600px;
    margin: auto;
`;

const Header = styled.h3`
    font-size: 16px;
    margin: 20px 0 20px 0;
    text-align: center;
`;

const SubHeader = styled.span`
    margin-bottom: 15px;
    white-space: pre-line;
    line-height: 20px;
    display: block;
`;

const ErrorStack = styled.span`
    white-space: pre-line;
    line-height: 20px;
    display: flex;
    justify-content: center;
`;

export default class ErrorPageBoundary extends React.Component<{ children?: React.ReactNode }, { error: Error | null }> {
    constructor(props: {}) {
        super(props);

        this.state = {
            error: null
        };
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return {
            error
        };
    }

    render() {
        if (this.state.error) {
            if (this.state.error.message === 'Unauthenticated seller') {
                removeCookie('zakeke_token');
                window.location.href = backofficeUrl('/Login');
            }

            return (
                <PageContainer>
                    <Section>
                        <EmptyListContainer>
                            <TopIcon>
                                <EmptyListIcon />
                            </TopIcon>
                            <Header>{T._('Error', 'Admin')}</Header>
                            <SubHeader>{T._('We are sorry but something went wrong. It could depends on different factors.', 'Admin')}</SubHeader>

                            <strong>{T._('This is what you can do:', 'Admin')}</strong>
                            <ul>
                                <li>{T._('Reload the page.', 'Admin')}</li>
                                <li>{T._('Clear your browser cache and then reload the page.', 'Admin')}</li>
                                <li>{T._('Log out and log in again.', 'Admin')}</li>
                            </ul>
                            <span>
                                {T._('If none of the above works, please contact us at', 'Admin')} <Link href='mailto: help@zakeke.com'>help@zakeke.com</Link>.
                            </span>
                        </EmptyListContainer>

                        <EmptyListContainer>
                            <Header>{T._('Error details:', 'Admin')}</Header>
                            <ErrorStack>{this.state.error.stack}</ErrorStack>
                        </EmptyListContainer>
                    </Section>
                </PageContainer>
            );
        }

        return this.props.children;
    }
}
